<template>
    <b-modal
        :id="'school-update-user-modal' + user.id"
        :title="$t('school.edit_user')"
        :ok-title="$t('common.save')"
        @ok="save($event)"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show"
    >
        <b-form-group :label="$t('common.first_name')" label-for="name">
            <b-alert show variant="danger" v-if="nameError">{{$t('school.first_name_mandatory')}}t</b-alert>

            <b-form-input
                id="name"
                v-model="name"
                required
                :placeholder="$t('common.first_name')"
            ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('common.infix')" label-for="preposition">
            <b-form-input
                id="preposition"
                v-model="preposition"
                :placeholder="$t('common.infix')"
            ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('common.last_name')" label-for="surname">
            <b-alert show variant="danger" v-if="surnameError">{{$t('validation.last_name_mandatory')}}</b-alert>

            <b-form-input
                id="surname"
                v-model="surname"
                required
                :placeholder="$t('common.last_name')"
            ></b-form-input>
        </b-form-group>

        <b-form-group label="E-mail:" label-for="email">

            <b-alert show variant="danger" v-if="emailError">{{$t('school.email_address_mandatory')}}</b-alert>

            <b-alert show variant="danger" v-if="emailDuplicateError">{{$t('school.choose_an_other_email_address')}}</b-alert>

            <b-form-input
                id="email"
                v-model="email"
                type="email"
                required
                placeholder="E-mail"
            ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('school.role')" label-for="role">
            <b-alert show variant="danger" v-if="roleError">{{$t('school.role_mandatory')}}</b-alert>

            <design-2021-apprentice-multiselect-component
                id="school-account-add-user-type"
                label="name"
                :options="options"
                :show-labels="false"
                :selected-in="selectedRole"
                v-model="selectedRole"
                :multiple-select="false"
            ></design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group :label="$t('common.username')"" label-for="username">
            <b-alert show variant="danger" v-if="usernameError">{{$t('school.accounts.username_mandatory')}}</b-alert>

            <b-alert show variant="danger" v-if="usernameDuplicateError">{{$t('school.choose_an_other_username')}}</b-alert>

            <b-form-input
                id="username"
                v-model="username"
                required
                :placeholder="$t('common.username')"
            ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('common.password')" label-for="password">
            <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                autocomplete="new-password"
                :placeholder="$t('common.password')"
            ></b-form-input>
        </b-form-group>


        <b-form-group :label="$t('school.schools')" label-for="schools">
                <design-2021-apprentice-multiselect-component
                    label="name"
                    :options="allSchools"
                    track-by="id"
                    v-model="schools">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
    </b-modal>
</template>

<script>
import {ords} from "../../../app";

export default {
    name: "design-2021-school-accounts-index-update-user-modal-component",
    props: [
        'user'
    ],
    data(){
        return{
            name: this.user.name,
            preposition: this.user.preposition,
            surname: this.user.surname,
            email: this.user.email,
            username: this.user.username,
            schools: this.user.schools,
            password: '',
            allSchools: [],
            selectedRole: this.selectedType(),
            options: [
                {name: this.$t('school.student'), value: 'student'},
                {name: this.$t('school.teacher'), value: 'teacher'}
            ],
            passwordError: false,
            usernameError: false,
            emailError: false,
            usernameDuplicateError: false,
            emailDuplicateError: false,
            roleError: false,
            surnameError: false,
            nameError: false,
            schoolsError: false,
        }
    },
    methods: {
        selectedType(){
            if(this.user.type === 'teacher'){
                return {name: this.$t('school.teacher'), value: 'teacher'}
            }
            else{
                return {name: this.$t('school.student'), value: 'student'}
            }
        },
        getAllSchools() {
            axios.get(this.routes.schoolsGet()).then (
                (response) => {
                    this.allSchools = response.data.map( (school) => {
                        return {
                            id: school.id,
                            name: school.name
                        }
                    })
                },
                (error) => {
                    this.alert.ajaxError(error);
                }
            )
        },

        save(event){
            this.nameError = this.name === '';
            //this.passwordError = this.password === '';
            this.emailError = this.email === '';
            this.usernameError = this.username === '';
            this.roleError = this.selectedRole === null;
            this.surnameError = this.surname === '';
            this.schoolsError = this.schools === '';

            event.preventDefault();

            if(this.nameError || this.usernameError || this.roleError || this.surnameError || this.schoolsError){
                event.preventDefault();
            }else{
                let data = {
                    name: this.name,
                    preposition: this.preposition,
                    surname: this.surname,
                    email: this.email,
                    role: this.selectedRole.value,
                    username: this.username,
                    password: this.password,
                    schools: this.schools.map( (school) => school.id),
                }

                this.axios.post(this.routes.schoolAccountUser(this.user.id), data).then(
                    (response) => {
                        ords.use('user').update(response.data, this.user.id);
                        this.$emit('update-table');

                        this.$bvModal.hide('school-update-user-modal' + this.user.id);

                        this.alert.success();
                    }, (error) => {
                        if(error.response.data.errors.email || error.response.data.errors.username)
                        {
                            if(error.response.data.errors.email){
                                this.emailDuplicateError = true;
                            }
                            else
                            {
                                this.emailDuplicateError = false;
                            }

                            if(error.response.data.errors.username){
                                this.usernameDuplicateError = true;
                            }
                            else
                            {
                                this.usernameDuplicateError = false;
                            }

                            this.alert.close();
                        }
                        else{
                            this.alert.ajaxError(error);
                        }
                    }
                )
            }
        },
        show(){
            this.name = this.user.name;
            this.preposition = this.user.preposition;
            this.surname = this.user.surname;
            this.email = this.user.email;
            this.username = this.user.username;
            this.schools = this.user.schools;
            this.password = '';
            this.selectedRole = this.selectedType();
            this.passwordError = false;
            this.usernameError = false;
            this.roleError = false;
            this.surnameError = false;
            this.nameError = false;
            this.getAllSchools();
        }
    }
}
</script>

<style scoped>

</style>
